import React from 'react';
import { LoginOutlined, PlayCircleOutlined, PauseCircleOutlined, LogoutOutlined, CheckOutlined, TrophyOutlined } from "@ant-design/icons";
import { Space, theme, Tooltip } from "antd";
import { _T } from "../../base-react/src/Localization";
import { RoundStatus as RoundStatusType } from "@vote4dance/judging-schema";
const { useToken } = theme;
export const RoundStatusIcon = (props) => {
    const { token } = useToken();
    var icon = React.createElement(LoginOutlined, { style: { color: token.colorInfo } });
    if (props.status === RoundStatusType.Ready) {
        icon = React.createElement(PlayCircleOutlined, { style: { color: token.colorHighlight } });
    }
    else if (props.status === RoundStatusType.Closed) {
        icon = React.createElement(PauseCircleOutlined, { style: { color: token.colorWarning } });
    }
    else if (props.status === RoundStatusType.Confirmed) {
        icon = React.createElement(LogoutOutlined, { style: { color: token.colorSuccess } });
    }
    return icon;
};
export const RoundStatus = ({ round }) => {
    const { token } = useToken();
    return (React.createElement(Space, null,
        React.createElement(Tooltip, { title: _T(`round.status.${round.round_status}.title`) },
            React.createElement(RoundStatusIcon, { status: round.round_status })),
        round.round_status == "ready" && round.round_judges_done ?
            React.createElement(Tooltip, { title: _T('judges.allSubmitted') },
                React.createElement(CheckOutlined, { style: { color: token.colorHighlight } }))
            : null,
        round.round_published ?
            React.createElement(Tooltip, { title: _T('round.status.published.title') },
                React.createElement(TrophyOutlined, null))
            : null));
};
